import {MilestoneAction, usePassRequestMilestone, MilestoneCheckProps} from '..'
export default function MilestoneCheck({
  type,
  request,
  disabled,
  tag,
  onArrowClick,
}: MilestoneCheckProps) {
  const {
    mutate: passRequestMilestone,
    isMutating: isPassRequestMilestoneMutating,
  } = usePassRequestMilestone(request.uuid, type)

  const handleCheck = () => passRequestMilestone()
  return (
    <MilestoneAction
      type={type}
      tag={tag}
      milestones={request.milestones}
      loading={isPassRequestMilestoneMutating}
      disabled={disabled}
      onClick={handleCheck}
      onArrowClick={onArrowClick}
    />
  )
}
